
export function getFullMediaUrl(path) {
    return window.media_url + path;
}

export function setLocalStorageItem(key, item) {
    try {
        let myStorage = window.localStorage;
        myStorage.setItem(key, item);
    }
    catch (e) {

    }
}

export function getLocalStorageItem(key) {
    const myStorage = window.localStorage;
    return myStorage.getItem(key);
}

export function clearLocalStorage(){
    window.localStorage.clear();
}

export function createFiltersUrl(obj) {
    let path = '';
    Object.keys(obj).forEach((index) => {
        path = path.concat(index);
        path = path.concat('=');
        path = path.concat(obj[index]);
        path = path.concat('&');
    });
    path = path.slice(0,-1);
    return path;
}

export function parseUrlParams(url) {
    let payload = {};
    if(url!==undefined ) {
        const params = url.split('&');
        let valueKeys = [];
        params.forEach(item => {
            valueKeys.push(item.split('='));
        });

        valueKeys.forEach(item => {
            payload[item[0]] = item[1];
        });

        delete payload[""];
    }
    return payload;
}

export function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

export function setCookie(key, value, exp) {
    document.cookie = key + '=' + value + ';' + 'expires=' + exp + ';';
}

export function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}


export function sortByOrderNum(arr) {
    return arr.sort((a,b)=>{
        let comparison = 0;
       if(a.order_num > b.order_num){
           comparison = 1;
       }
       else if (a.order_num < b.order_num) {
           comparison = -1;
       }
       return comparison;
    });
}

export function peepsScoreCalc(score) {
    score = parseFloat(score);
    let res = (0.4 * (10 - score) + score);
    return res * 10;
}